import { Box } from "@mui/material";
import { Card } from "src/components/atoms/Card";
import { DashboardSummaryCard } from "../DashboardSummaryCard";
import {
  useShareRangeAnalysisCounts,
  useLocationAnalysisCounts,
} from "../../hooks";

export function DashboardReportsSummary() {
  const shareRangeCounts = useShareRangeAnalysisCounts();
  const locationCounts = useLocationAnalysisCounts();

  return (
    <Card title="Reports" sx={{ mb: 6 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 4,
        }}
      >
        <DashboardSummaryCard
          title="Share Range Analysis"
          items={[
            {
              label: "Pending approval",
              value: shareRangeCounts.pendingApproval,
              href: "/reports/share-range-analysis-events?view=pending_approval",
              color: "#F57C00",
            },
            {
              label: "Pending delivery",
              value: shareRangeCounts.pendingDelivery,
              href: "/reports/share-range-analysis-events?view=pending_delivery",
              color: "#1976D2",
            },
            {
              label: "Recently delivered",
              value: shareRangeCounts.recentlyDelivered,
              href: "/reports/share-range-analysis-events?view=recently_delivered",
              color: "#388E3C",
            },
          ]}
        />
        <DashboardSummaryCard
          title="Location Analysis"
          items={[
            {
              label: "Pending approval",
              value: locationCounts.pendingApproval,
              href: "/reports/location-analysis-events?view=pending_approval",
              color: "#F57C00",
            },
            {
              label: "Pending delivery",
              value: locationCounts.pendingDelivery,
              href: "/reports/location-analysis-events?view=pending_delivery",
              color: "#1976D2",
            },
            {
              label: "Recently delivered",
              value: locationCounts.recentlyDelivered,
              href: "/reports/location-analysis-events?view=recently_delivered",
              color: "#388E3C",
            },
          ]}
        />
      </Box>
    </Card>
  );
}
